/* tslint:disable */

declare var Object: any;
export interface SFElearningSF6Interface {
  "id"?: number;
}

export class SFElearningSF6 implements SFElearningSF6Interface {
  "id": number;
  constructor(data?: SFElearningSF6Interface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFElearningSF6`.
   */
  public static getModelName() {
    return "SFElearningSF6";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFElearningSF6 for dynamic purposes.
  **/
  public static factory(data: SFElearningSF6Interface): SFElearningSF6{
    return new SFElearningSF6(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFElearningSF6',
      plural: 'SFElearningSF6s',
      path: 'SFElearningSF6s',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFElearningSF6.ts